import React, { useState } from 'react'
import Button from '../../../../partials/Button'
import './Popup.scss'

const Popup = props => {

    const [cleanup, setCleanup] = useState(false)

    const data = props.data || {
        scrim: true,
        header: 'Error',
        body: "Popup data prop not provided",
        button: "button"
    }

    const handleButtonClick = () => {
        setCleanup(true);
        setTimeout(() => {
            if (props.onClose) props.onClose();
            if (props.onComplete) props.onComplete();
        }, (props.instant === true ? 0 : 600))

    }

    const getAnimationClasses = () => {
        if (props.instant === true) return '';
        return cleanup ? 'cleanup' : 'not-cleanup'
    }

    return (
        <div className={`Popup ${getAnimationClasses()} ${props.class || ''} ${props.centered === false ? 'not-centered' : 'centered'} `}>
            <div className="body" >
                <div className="body-content">
                    <div className="header" dangerouslySetInnerHTML={{ __html: data.header }}></div>
                    <div className="content-body" dangerouslySetInnerHTML={{ __html: data.body }}></div>
                </div>
                <Button text={data.button} onClick={handleButtonClick} />
            </div>
        </div>
    )
}

export default Popup;
